import { GoogleMapLocation } from "components/GoogleMap/GoogleMapLocation";
import { ViewOnMap } from "components/GoogleMap/ViewOnMap";
import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";

interface AirportSidePanelDetailsProps {
  airport: server.dto.Airport
}

export const AirportSidePanelDetails = (props: AirportSidePanelDetailsProps) => {
  const airport = props.airport;

  const localDateFormatter = Intl.DateTimeFormat(site.culture.uiLocale, { timeZone: airport.timeZoneRegionName, hour: "2-digit", minute: "2-digit" });

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    fields={[{
      key: "name",
      label: RESX.GeneralLabels.Name,
      render: () => <SmallDetails
        label={airport.name}
        subLabel={airport.location}
      />
    }, {
      key: "iata",
      label: "IATA",
      isEmpty: !airport.iata,
      render: () => <span>{airport.iata}</span>
    }, {
      key: "icao",
      label: "ICAO",
      isEmpty: !airport.icao,
      render: () => <span>{airport.icao}</span>
    }, {
      key: "localTime",
      label: RESX.DateTime.LocalTime,
      render: () => <SmallDetails
        label={localDateFormatter.format(new Date())}
        subLabel={airport.timeZoneRegionName}
      />
    }]}
    additionalContent={<>
      <ViewOnMap height={400}>
        <GoogleMapLocation pin={{ type: "airport" }} location={airport.point} />
      </ViewOnMap>
    </>}
  />
}